import React from "react";
import Card from "../Carts/Card";
import Sport from "../News/Sport";
import NewsImg from "../News/NewsImg";
import Pop from "../News/Pop";
import "./main.css";
import Logo from "../acepts/tahlil.svg";
import Actual from "./../News/Actual";
import Video from "../News/Video";
import { NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Main(props) {
  AOS.init();
  AOS.refresh();
  return (
    <div className="containers">
      <div className="main_block">
        <div className="row pt-4">
          <div className="col-md-9 main">
            <NewsImg />
            <Sport />
          </div>
          <Pop />
        </div>

        {/* Start Actual News =========================================== */}
        <div className="row actual_parent py-4 my-5">
          <div className="video_title pb-3">
          <div className="video_title_text d-flex align-items-center">
            <img src={Logo} alt="Error img" />
            <h3 className="ms-2">Actual news </h3>
          </div>
          <h5 className="link_news"><NavLink to="">All News <i class="bi bi-arrow-right ms-2"></i></NavLink></h5>
        </div>
          <div className="col-md-7">
            <Card />
          </div>
          <div className="col-md-5 py-1 actual_cart">
            <Actual />
          </div>
        </div>
        {/* End Actual News =========================================== */}

        {/* Start Video News =========================================== */}
        <div className="video_news mt-5 py-4">
          <div className="row">
            <Video />
          </div>
        </div>
        {/* End Video News =========================================== */}
      </div>
    </div>
  );
}

export default Main;
